import * as yup from 'yup'

const schema = yup.object().shape({
  tipoPesagem: yup.string().required('Tipo de pesagem é obrigatório.'),
  peso: yup.string().when('tipoPesagem', {
    is: 'pesagem',
    then: (schema) => schema.required('Peso é obrigatório.'),
    otherwise: (schema) => schema.nullable()
  }),
  perimetro: yup.string().when('perimeterIsRequired', {
    is: true,
    then: (schema) => schema.required('Perímetro é obrigatório.'),
    otherwise: (schema) => schema.nullable()
  }),
  fitaComprimento: yup.string().when('tipoPesagem', {
    is: 'pesagem_fita',
    then: (schema) => schema.required('Comprimento é obrigatório.'),
    otherwise: (schema) => schema.nullable()
  }),
  fitaPerimetro: yup.string().when('tipoPesagem', {
    is: 'pesagem_fita',
    then: (schema) => schema.required('Perímetro torácico é obrigatório.'),
    otherwise: (schema) => schema.nullable()
  })
})

export default schema
